import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { GlobalContextProvider } from './utils/GlobalContext';
// import Info from './pages/Info';
// import Links from './pages/Links';
// import Things from './pages/things/Things';
// import ThingDetail from './pages/ThingDetail';
// import TOS from './pages/TOS';
import Empty from './pages/Empty';

// import Signals from './pages/signals/Signals';
// import SignalDetail from './pages/SignalDetail';
// import Frame from './pages/Frame';
import './Header.css';
import './App.css';
// import Header from './Header';
import EmptyHeader from './EmptyHeader';

export default function App() {
  return (
    <GlobalContextProvider>
      <Router>
        <div className="App">
          {/* <Header /> */}
          <EmptyHeader />
          <Routes>
            <Route path="/" element={<Empty />} />
            {/* <Route path="/" element={<Things />} />
            <Route path="/tos" element={<TOS />} />
            <Route path="/info" element={<Info />} />
            <Route path="/links" element={<Links />} />
            <Route path="/things/:id" element={<ThingDetail />} /> */}

            {/* uncomment below routes when we have content for them */}
            {/* <Route path="/frame" element={<Frame />} /> */}
            {/* <Route path="/signals" element={<Signals />} /> */}
            {/* <Route path="/signals/:id" element={<SignalDetail />} /> */}
          </Routes>
        </div>
      </Router>
    </GlobalContextProvider>
  );
}
